module.exports = __webpack_public_path__ + "img/course.a5c80ac8.svg";